import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { motion } from 'framer-motion';
import { pushToast } from './ToastViewport';
export const UploadDropzone = () => {
    const inputRef = useRef(null);
    const openPicker = () => {
        inputRef.current?.click();
    };
    const onFilesSelected = (event) => {
        const count = event.target.files?.length ?? 0;
        pushToast(count > 0 ? `${count} file${count > 1 ? 's' : ''} selected.` : 'No file selected.', count > 0 ? 'success' : 'error');
    };
    const useVoiceInput = () => {
        const speech = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!speech) {
            const fallback = window.prompt('Voice input is not available here. Enter food details manually:');
            if (fallback?.trim()) {
                pushToast(`Captured details: "${fallback.trim()}"`, 'success');
            }
            else {
                pushToast('Voice input is not supported in this browser.', 'error');
            }
            return;
        }
        const recognition = new speech();
        recognition.lang = 'en-US';
        recognition.onerror = () => {
            const fallback = window.prompt('Voice capture failed. Enter food details manually:');
            if (fallback?.trim()) {
                pushToast(`Captured details: "${fallback.trim()}"`, 'success');
                return;
            }
            pushToast('Voice input failed. Please try again.', 'error');
        };
        recognition.onresult = () => pushToast('Voice input captured.', 'success');
        pushToast('Listening for donation details...', 'success');
        recognition.start();
    };
    return (_jsxs(motion.div, { whileHover: { scale: 1.01 }, className: "glass-panel rounded-[28px] border border-dashed border-emerald-300/70 p-6 text-center text-[color:var(--text)]", children: [_jsx("input", { ref: inputRef, type: "file", accept: "image/*", multiple: true, className: "hidden", onChange: onFilesSelected }), _jsx("div", { className: "mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-r from-green-500/20 to-orange-500/20 text-xl font-semibold text-[color:var(--text)]", children: "+" }), _jsx("h3", { className: "mt-4 text-lg font-semibold text-[color:var(--text)]", children: "Drag and drop food images" }), _jsx("p", { className: "mt-2 text-sm text-[color:var(--muted)]", children: "Preview uploads instantly, score food quality, and autofill metadata from the image." }), _jsxs("div", { className: "mt-5 flex flex-wrap justify-center gap-3", children: [_jsx("button", { onClick: openPicker, className: "ripple-button rounded-2xl bg-[image:var(--accent)] px-4 py-2 text-sm font-semibold text-white", children: "Choose files" }), _jsx("button", { onClick: useVoiceInput, className: "soft-chip rounded-2xl px-4 py-2 text-sm font-semibold text-[color:var(--text)]", children: "Use voice input" })] })] }));
};
